import { defineNuxtPlugin } from 'nuxt/app';
import axios from '@/api.instance';

export default defineNuxtPlugin(() => ({
    provide: {
        axios,
    },
}));
